module.exports = __webpack_public_path__ + "static/media/chart.ed2f373e.svg";